import { print } from 'graphql';
import gql from 'graphql-tag';
import type { RxCollection, RxDocument, RxJsonSchema } from 'rxdb';

import { rootStore } from '../../mobx-models/Root';
import { BaseEntity } from '../../models/BaseEntity';
import { SYNC_LIMIT_LOW } from '../../utilities/constants';
import defaultDoc from '../Shared/defaultDoc';

export interface EquipmentDeficiencyAttachment extends BaseEntity {
  readonly equipmentDeficiencyId: string;
  readonly fileName: string;
  readonly uploadedById: string;
  readonly createdOn: string | null;
}
export type EquipmentDeficiencyAttachmentCollection =
  RxCollection<EquipmentDeficiencyAttachment> | null;
export type EquipmentDeficiencyAttachmentDocument = RxDocument<EquipmentDeficiencyAttachment>;

export const equipmentDeficiencyAttachmentSchema: RxJsonSchema<EquipmentDeficiencyAttachment> = {
  type: 'object',
  version: 0,
  description: 'describes a EquipmentDeficiencyAttachment object',
  primaryKey: 'id',
  properties: {
    id: { type: 'string', maxLength: 36 },
    updatedAt: { type: 'number' },
    isDeleted: { type: 'boolean' },
    version: { type: 'number' },
    equipmentDeficiencyId: { type: 'string' },
    fileName: { type: 'string' },
    uploadedById: { type: 'string' },
    createdOn: { type: 'string' },
  },
};

export const equipmentDeficiencyAttachmentPullQueryBuilder = (
  doc: EquipmentDeficiencyAttachment,
) => {
  if (!doc) {
    doc = { ...defaultDoc };
  }

  const query = print(gql`
    query equipmentDeficiencyAttachmentFeed(
      $lastUpdateAt: Float!
      $borerEquipmentId: ID!
      $limit: Int!
    ) {
      equipmentDeficiencyAttachmentFeed(
        borerEquipmentId: $borerEquipmentId
        lastUpdateAt: $lastUpdateAt
        limit: $limit
      ) {
        id
        fileName
        equipmentDeficiencyId
        isDeleted
        updatedAt
        version
      }
    }
  `);

  return {
    query,
    variables: {
      lastUpdateAt: doc.updatedAt,
      borerEquipmentId: rootStore.equipment.selectedBorerId,
      limit: SYNC_LIMIT_LOW,
    },
  };
};

export const equipmentDeficiencyAttachmentPushQueryBuilder = (
  doc: EquipmentDeficiencyAttachment,
) => {
  doc = doc[0];

  const query = print(gql`
    mutation createEquipmentDeficiencyAttachment(
      $attachmentId: ID!
      $createdOn: AWSDateTime
      $equipmentDeficiencyId: ID!
      $fileName: String!
      $uploadedById: ID!
    ) {
      createEquipmentDeficiencyAttachment(
        input: {
          uploadedById: $uploadedById
          fileName: $fileName
          equipmentDeficiencyId: $equipmentDeficiencyId
          createdOn: $createdOn
          attachmentId: $attachmentId
        }
      ) {
        id
        isWorkOrderRequired
        siteId
      }
    }
  `);

  const variables = {
    ...doc,
    attachmentId: doc.id,
  };

  return {
    query,
    variables,
  };
};

export const equipmentDeficiencyAttachmentPushModifier = (doc: EquipmentDeficiencyAttachment) => {
  const obj = {
    ...doc,
  };

  const propertyBlackList = ['updatedAt', '_deleted', '_attachments', '_rev'];
  propertyBlackList.forEach(property => {
    obj[property] = undefined;
  });

  return obj;
};

export default {};
